module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-rule-522c7d84b1eeee1c47737b994583c0f5.png";